import { Pipe, PipeTransform } from '@angular/core';
import { formatDate } from '@angular/common';
import { TranslateService } from '@ngx-translate/core';
import { registerLocaleData } from '@angular/common';
import localeIt from '@angular/common/locales/it';

registerLocaleData(localeIt);

@Pipe({
  name: 'localDate',
  standalone: true,
  pure: false
})
export class DatePipe implements PipeTransform {
  constructor(private readonly translateService: TranslateService) {}

  transform(value: Date | undefined): string {
    if (!value) return '';

    const currentLang = this.translateService.currentLang || this.translateService.defaultLang;
    const format = currentLang === 'it-IT' ? 'dd-MM-yyyy' : 'MM-dd-yyyy';
    
    try {
      // Usa il locale completo invece del solo codice lingua
      return formatDate(value, format, currentLang);
    } catch (error) {
      console.error('Error formatting date:', error);
      return '';
    }
  }
}